export default [
    {
        name: 'cadastro-municipio',
        path: 'municipio',
        redirect: 'municipio/index',
        component: () => import(/* webpackChunkName: 'cadastro-municipio' */ '@/views/cadastro/municipio/Index'),
        children: [
            {
                meta: {title: 'Lista de municípios'},
                name: 'cadastro-municipio-index',
                path: 'index',
                component: () => import(/* webpackChunkName: 'cadastro-municipio' */ '@/views/cadastro/municipio/List.vue'),
            },
        ],
    },
]